<template>
    <section class="wrapper">
        <app-LeftNavigation></app-LeftNavigation>
        <section class="main_right_sidesec">
			<div class="loader-info" v-if="pageLoader">
				<img src="../../../static/prism_admin/images/prism_loader.gif" />
			</div>
			<!---------------------end of loader-------------------------------->
            <router-view/>  
        </section>  
    </section>
</template>

<script>
    import WOW from '../../../static/common/js/wow.min.js'
	import LeftNavigation from './shared/left_navigation'
	import Footer from './shared/footer'
	 import * as types from '@/types'
    import { mapActions } from 'vuex'
  
  export default {
    name: 'PrismApp',
    data() {
        return {  
            DEFAULT_SHOW_ENTERIES : "10",
			pageLoader : false
        }
    },
    methods:{
			...mapActions({
                _runStateLoad: types.RUN_STATE_LOAD,
            }),
		},
    components: {    
      appLeftNavigation: LeftNavigation,            
      appFooter: Footer,      
    },
	created(){
		this.$store.dispatch(types.RUN_STATE_LOAD)
		this._runStateLoad({'router' : this.$router}) 
		/*var get_user_state = this.$store.getters['GET_USER'];
		const r = this.$router
		if(!get_user_state.loggedIn){
			r.replace('/')
		}*/
	},
	mounted(){
		
		
		/*$("body").overlayScrollbars({});
		$(".rightbar_content").overlayScrollbars({});
		$(".p_searchresult").overlayScrollbars({});
		$(".indicespop").overlayScrollbars({});
		
		
		$(".showstocklist").click(function(){
			$(".p_searchresult").toggleClass("show");
		});*/
	}
  }
</script>




// WEBPACK FOOTER //
// src/components/prism_admin/index.vue